<template>
	<div id="result_scroller" v-on:scroll="scrolled" v-on:touchmove="scrolled" :class="[vehicleResultsReady ? 'query_completed' : 'query_running']">
        <div id="results_loader_wrapper" v-show="!vehicleResultsReady" :class="[!vehicleResultsReady ? 'appear' : '']">
            <div id="results_loader" :class="[!vehicleResultsReady ? 'appear' : '']"></div>
        </div>
        <div id="resultsFailedWrapper" v-show="vehicleQueryFailed">
            <div id="oppsMessage">
                We have encountered a communication issue. 
                <br/>
                Please refresh.
            </div>
            <div id="reloadButton" @click="retryFailedQuery">
                <div id="refreshIcon">
                    &#8635;
                </div>
                <div id="refreshText">
                    Refresh
                </div>
            </div>
        </div>
        <div id="resultsEmptyWrapper" v-show="hasResults">
            There were no vehicles found that match your selected search parameters. 
            <br/>
            Please adjust one of more of the filters to the left.
        </div>
		<div id="results">
			<vehicle-display v-for="(car, index) in matchedVehicles" :key="car.VIN" :car="car" :matchIndex="index" class="result_item"/>
            <div id="paginationLoaderWrapper" v-if="notLastPage">
                <div id="paginationLoader" v-if="notLastPage && resultsPaging" :class="[resultsPaging ? 'appear' : 'disappear']">
                </div>
            </div>
		</div>
	</div>
</template>

<script>
    import VehicleDisplay from './VehicleDisplay' 
    import { computed } from 'vue'
    import { useStore } from 'vuex'

	export default {
        data() {
            return {
            }
        },
        setup() {
            const store = useStore();

            return {
                // access a state in computed function
                matchedVehicles: computed(() => store.getters.getMatches)
            }
        },
        mounted() {
            let vehicleScroller = document.getElementById('result_scroller');

            vehicleScroller.scrollTop = this.$store.getters.getSearchScrollPosition;
        },
        computed: {
            vehicleResultsReady() {
                return (!this.$store.getters.isQueryRunning || this.$store.getters.getCurrentPage > 0 || this.vehicleQueryFailed);
            },
            vehicleQueryFailed() {
                return this.$store.getters.getQueryFailure;
            },
            resultsPaging() {
                return (this.$store.getters.isQueryRunning && (this.$store.getters.getCurrentPage > 0));
            },
            notLastPage() {
                return (this.$store.getters.getCurrentPage * this.$store.getters.getPageLimit) < this.$store.getters.queryCount;
            },
            hasResults() {
                return !this.$store.getters.isQueryRunning && this.$store.getters.doesQueryHaveMatches;
            },
            vdpOpen() {
                return this.$store.getters.vehicleGallerySelected;
            }
        },
        watch: {
            vehicleResultsReady(now, then) {
                if(!now && (now != then)) {
                    let vehicleScroller = document.getElementById('result_scroller');

                    this.$store.commit('setSearchScrollPosition', 0);
                    vehicleScroller.scrollTo(0,0);
                }
            },
            vdpOpen(open) {
                if(open != null && this.vehicleResultsReady) {
                    let vehicleScroller = document.getElementById('result_scroller');
                    let currentPosition = vehicleScroller.offsetHeight + vehicleScroller.scrollTop - (window.innerHeight * .8);
                
                    this.$store.commit('setSearchScrollPosition', currentPosition);
                }
            }
        },
		methods: {
            scrolled: function(event) {
                var searchResults = event.target;

                if((searchResults.offsetHeight + searchResults.scrollTop + (window.innerHeight * 5 * .9)) >= (searchResults.scrollHeight)) {
                    if(!this.$store.getters.isQueryRunning) {
                        console.log("NO query running requesting next PAGE");
                        let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                        this.$gtag.event('paginate', {'event_category': 'vehicle_results','event_label': eventLabel});
                        this.$store.dispatch('pageCurrentQuery');
                    }
                    else {
                        console.log("A query is currently running");
                    }
                }
            },
            retryFailedQuery() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('failure_retry', {'event_category': 'vehicle_results','event_label': eventLabel});
                this.$store.commit('setQueryFailure', false);
                this.$store.dispatch('runSearchQuery');
            }
		},
		components: {
            'vehicle-display': VehicleDisplay
		},
	}
</script>

<style>
    #result_scroller {
        background-color:#FFF;
        height: calc(80 * var(--vh));
        width: inherit;
        /*overflow-y: scroll;*/
        overflow-x: hidden;
        position: absolute;
        height: calc(80 * var(--vh));
        width: calc(90 * var(--vw));
    }

    .query_completed {
        overflow-y: scroll;
    }

    .query_running {
        overflow-y: hidden;
    }

    .inmobile #result_scroller {
        height: calc(65 * var(--vh));
        top: calc(30 * var(--vh));
        width: calc(100 * var(--vw));
        max-width: cal(100 * var(--vw));
        left: calc(0 * var(--vw));
    }

    ::-webkit-scrollbar {
        width: 0px;  /* remove scrollbar space */
        background: transparent;  /* optional: just make scrollbar invisible */
    }

    #results {
        height: calc(80 * var(--vh));
        min-height: calc(80 * var(--vh));
    }
    
    .result_item {
        width: 100%;
        border-bottom: 1px solid #aaa;
        /*height: calc(16 * var(--vh));*/
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
    }

    .inmobile .result_item {
        border-top: 1px solid #aaa;
        border-bottom: unset;
    }

    #resultsEmptyWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: calc(2.2 * var(--vw));
        font-weight: bolder;
    }

    #resultsFailedWrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: calc(2.2 * var(--vw));
        font-weight: bolder;
    }

    #oppsMessage {
        font-size: calc(2.2 * var(--vw));
        font-weight: bolder;
        width: 100%;
        height: 60%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #reloadButton {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--mccluskeyBlue); /*#0077C0;*/ /*#0079B6;*/ /*#AF873F;*/
        border-radius: calc(var(--vratio) * var(--vh));/*5px;*/
        width: calc(12 * var(--vw));
        height: calc(3.4 * var(--vw));
        font-size: calc(2 * var(--vw));
        cursor: pointer;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bold;
        color: white;
        border: solid white .75px;
    }

    #refreshIcon {
        transform: rotate(90deg);
        margin: calc(1 * var(--vw));
    }
    
    #reloadButtonWrapper:hover {
        color: #2c3e50;
    }

    #results_loader_wrapper {
        position: absolute;
        height: inherit;
        width: inherit;
        background-color: black;
        z-index: 1;
        opacity: 0;
        transition: opacity 1s;
    }

    #results_loader_wrapper.appear {
        opacity: .4;
    }

    #results_loader {
        position: absolute;
        left: calc(45 * var(--vw));
        top: calc(43.5 * var(--vh));
        z-index: 2;
        width: 100px;
        height: 100px;
        margin: -75px 0 0 -75px;
        border: 8px solid rgb(172,179,183);
        border-radius: 50%;
        border-top: 8px solid #207BD3;
        width: 90px;
        height: 90px;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        opacity: 0;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
    }

    .inmobile #results_loader {
        left: calc(55 * var(--vw));
        top: calc(35 * var(--vh));
    }

    #results_loader.appear {
        opacity: 1;
    }
    
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    #paginationLoaderWrapper {
        height: calc(4 * var(--vw));
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    #paginationLoader {
        z-index: 2;
        border: 7px solid rgb(172,179,183);
        border-radius: 50%;
        border-top: 8px solid #207BD3;
        width: calc(2 * var(--vw));
        height: calc(2 * var(--vw));
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        /*opacity: 0;*/
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
        position: absolute;
        bottom: calc(1 * var(--vh));
        left: calc(43 * var(--vw));
    }

    #paginationLoader.appear {
        opacity: 1;
    }

    #paginationLoader.disappear {
        opacity: 0;
    }

    .inmobile #paginationLoader {
        bottom: calc(6 * var(--vh));
        left: calc(44 * var(--vw));
    }
</style>
